export const translateFolderId = '96cf61eb-d3b2-42ab-b2c0-eddfe884d4d4';